export default "__VITE_ASSET__DmBP_i8E__"